/**
 * RedRock Monitoring Admin BFF
 *
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
import { SortExpression } from './sort-expression';
import { DateTimePeriod } from './date-time-period';


export interface EquipmentExportRequest { 
    keyword?: string | null;
    ipRanges?: Array<string> | null;
    excludeIpRanges?: Array<string> | null;
    ipList?: Array<string> | null;
    modelIds?: Array<string> | null;
    workerIds?: Array<string> | null;
    clientIds?: Array<string> | null;
    facilityIds?: Array<string> | null;
    containerIds?: Array<string> | null;
    statusIds?: Array<number> | null;
    modeIds?: Array<number> | null;
    sortExpressions?: Array<SortExpression> | null;
    datePeriod?: DateTimePeriod;
    reportDate?: string | null;
}

